import axios from "axios";
import ApiUrl from "./ApiUrl";
import CryptoJS from "crypto-js";
import { msgTypes } from "../constants/msgTypes.js";
import { RouteType } from "../constants/RouteType.js";
export class AuthService {

  static checkoutPaymentInit = async (requestData) => {
    const url = ApiUrl.baseUrl + RouteType.paymentActiveNew;
    const res = await axios.post<string>(url, requestData, {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
    });
    return JSON.parse(JSON.stringify(res.data));
  };

  static paymentActive = async (requestData: Object) => {
    const url = ApiUrl.baseUrl + RouteType.paymentActiveNew;
    const res = await axios.post<string>(url, requestData, {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
    });

    return JSON.parse(JSON.stringify(res.data));
  };

  static checkStatus = async (requestData, _token?: string) => {
    const url = ApiUrl.baseUrl + RouteType.txnPayState;
    const res = await axios.post<string>(url, requestData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return JSON.parse(JSON.stringify(res.data));
  };
  static encrypt = async (
    strToEncrypt: string,
    secretKey: string,
    salt: string
  ) => {
    const ITERATION_COUNT = msgTypes.ITERATION_COUNT;
    const KEY_LENGTH = msgTypes.KEY_LENGTH; // AES-256 key length
    try {
      const iv = CryptoJS.lib.WordArray.random(16); // 16 bytes for AES block size
      const key = CryptoJS.PBKDF2(secretKey, salt, {
        keySize: KEY_LENGTH / 32, // 256 bits / 32 bits per word = 8 words
        iterations: ITERATION_COUNT,
      });
      const encrypted = CryptoJS.AES.encrypt(strToEncrypt, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7, // Equivalent to PKCS5Padding in Java
        mode: CryptoJS.mode.CBC, // CBC mode
      });
      const encryptedData = iv.concat(encrypted.ciphertext);
      return encryptedData.toString(CryptoJS.enc.Base64);
    } catch (error) {
      console.error("Encryption failed", error);
      return null;
    }
  };
}
